import { render, staticRenderFns } from "./coach_view.vue?vue&type=template&id=2921ea02&scoped=true&"
import script from "./coach_view.vue?vue&type=script&lang=js&"
export * from "./coach_view.vue?vue&type=script&lang=js&"
import style0 from "./coach_view.vue?vue&type=style&index=0&id=2921ea02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921ea02",
  null
  
)

export default component.exports